import React, { useEffect, useState, useRef } from "react";
import { Table, Input } from "antd";
// import { getApmcApplicationDetails, getApplications, getPanelApplications } from "../../auth/services/privateapicalling";

import { useSelector } from "react-redux";
import { label } from "yet-another-react-lightbox/*";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Ellipsis } from "react-bootstrap/esm/PageItem";
import { all_routes } from "../router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { getCountOfAggreement } from "../auth/services/apiCalling";
import { getAggreementDetails } from "../auth/services/apiCalling";
import Select from 'react-select';
import { getAggreementFormReview } from "../auth/services/apiCalling"
import { Option } from "../application/CommonSelect";
import CommonSelect from "../../core/common/commonSelect";

interface StatusProp {
  status: any;
}
const AggreementApplicationTable: React.FC<StatusProp> = ({ status }) => {
  const routes = all_routes;

  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail?.Role?.Role_Identifier;

 

  const language = useSelector((state: any) => state.auth.language);
  const token = useSelector((state: any) => state.auth.token);
  const navigate = useNavigate();
  const [aggreementCount, setAggreementCount] = useState<any>();
  const [aggreementdetails, setAggreementdetails] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [totalRec, setTotalRec] = useState(1000000000); // Default size

  const [selectPending, setSelectPending] = useState<Option | null>(status[0]);

  ///fetch count of aggreement ...!
  const fetchCount = async () => {
    const ress = await getCountOfAggreement(token);
    if (ress?.success) {
      setAggreementCount(ress?.data);
      // setTotalRec(ress?.data?.totalApplications)
    } else {
      toast.error(ress?.message, { position: "top-right" });
    }
  }

  const fetchAggreementDetails = async () => {
    setLoading(true)
    try {
      const ress = await getAggreementDetails(token, selectPending?.value, totalRec);
      if (ress?.success) {
        setAggreementdetails(ress?.data);
        
      } else {
        toast.error(ress?.message, { position: "top-right" });
      }
    } catch (ee) {
      toast.error(ee, { position: "top-right" });
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCount();
    fetchAggreementDetails();
  }, [token, selectPending])


  const handleRedirect = () => {
    navigate("/marketing-board-registration");
  };

  const tableData = aggreementdetails
    ?.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .map((dt: any, ind: any) => ({
      key: ind + 1,
      Sponsor_Id: dt?.applicationId,
      Applied_Date: dt?.createdAt,
      Status: dt?.status,
      appStatusLevel: dt?.appStatusLevel
    }));




  const handleRoute = (record: any) => {
    //getDocID(record)
          if (record?.appStatusLevel == "forwardToMBAAterApproval" || record?.appStatusLevel == "forwardToMBMDAterApproval" || record?.appStatusLevel == "forwardToMBAAfterApprovalResubmissionn" || record?.appStatusLevel == "forwardToMBMDAfterApprovalResubmissionn") {
        navigate(routes.pdfDocReview, { state: record });
      } else {
        navigate(routes.mbAgreement, { state: record });
      }
  }



  const handleChange = (selectedOption: any) => {

    setSelectPending(selectedOption)
  };

  const columns = [
    {
      title: "Sr N.",
      dataIndex: "key",
      // render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Sponsor Id",
      dataIndex: "Sponsor_Id",
      // sorter: (a, b) => a.FatherName.length - b.FatherName.length,
    },
    {
      title: "Applied Date",
      dataIndex: "Applied_Date",
      render: (date: string) =>
        date
          ? new Date(date).toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })
          : "N/A",
    },
    {
      title: language?.application_status,
      dataIndex: "Status",
      render: (status: string) => {
        const statusMapping: Record<string, string> = {
          PermanentReject: "Permanent reject",
          approvedUnsigned: "Approve Unsigned",
          reject: "Raised Query",
          pending: "Pending",
          resubmission: "Resubmission",
          draft: "Draft",
          approve: "Approved"

        };

        return <span>{statusMapping[status] || status}</span>;
      },
    },
    // {
    //   title: "Application Status level",
    //   dataIndex: "appStatusLevel",
    // },
    {
      title: "Action (Review)",
      dataIndex: "Name",
      render: (text: any, record: any) => (
        <button className="btn btn-info"
          disabled={
            roleIdentifier === "MBMD"
              ? false // MBMD can review all applications
              : ["pendingAtSponsor", "forwardToSponsorAterApproval"].includes(record?.appStatusLevel)
          }
          onClick={() => { handleRoute(record) }}>Review</button>
      ),
      // sorter: (a, b) => a.Name.length - b.Name.length,
    }
  ]




  return (
    <>

      <div>
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Agreement Application Review</h2>
            </div>
          </div>

          {/* <div className="d-flex justify-content-between mb-3" style={{ fontSize: "1.25rem" }}>
              <div className="col-3 bg-info-subtle rounded-3 p-3" style={{ height: "120px", width: "300px" }}>Total Applications <h1 className="text-info" style={{ fontSize: "3rem" }}>{aggreementCount?.totalApplications}</h1></div>
              <div className="col-3 bg-warning-subtle rounded-3 p-3" style={{ height: "120px", width: "300px" }}>Pending <h1 className="text-warning" style={{ fontSize: "3rem" }}>{aggreementCount?.pendingApplications+aggreementCount?.forwardToMD}</h1></div>
              <div className="col-3 border-secondary bg-secondary-subtle rounded-3 p-3" style={{ height: "120px", width: "300px" }}>Approved<h1 className="text-success" style={{ fontSize: "3rem" }}>{aggreementCount?.approvedApplications}</h1></div>
              <div className="col-3 bg-dark-subtle rounded-3 p-3" style={{ height: "120px", width: "300px" }}>Queried<h1 className="text-secondary" style={{ fontSize: "3rem" }}>{aggreementCount?.queryRaised}</h1></div>
            </div> */}

          {/* /Breadcrumb */}

          {/* Performance Indicator list */}
          <div className="card">


            <div className="card-body p-0">

              <div className="table-top-data">
                <div className="row p-3">
                  <div className="col-sm-12 d-flex justify-content-end">

                    <CommonSelect
                      className="mx-3 basic-single"
                      options={status}
                      onChange={handleChange}
                      defaultValue={selectPending}

                    />

                    {/* <Input
                        placeholder="Search Application Id..."
                        style={{ width: 250 }}
                        allowClear
                      /> */}
                  </div>
                </div>
              </div>

              <ToastContainer />

              <Table
                className="table datanew dataTable no-footer"
                // rowSelection={Selections ? rowSelection : undefined}
                columns={columns}
                rowKey={"Sponsor_Id"}
                rowHoverable={false}
                dataSource={tableData}
                loading={loading}
                pagination={{
                  locale: { items_per_page: "" },
                  nextIcon: <i className="ti ti-chevron-right" />,
                  prevIcon: <i className="ti ti-chevron-left" />,
                  defaultPageSize: 5,
                  showSizeChanger: true,
                  pageSizeOptions: ["5", "10", "20", "30"],
                  showTotal: (total, range) => `Showing ${range[0]} - ${range[1]} of ${total} entries`,
                }}
       
              />
            </div>

          </div>
          {/* /Performance Indicator list */}
        </div>
      </div>

    </>
  );
};

export default AggreementApplicationTable;
